<template>
	<div class="tab-pane fade" id="admanager-tab-pane" role="tabpanel" aria-labelledby="admanager-tab" tabindex="0">
		<h3>광고관리</h3>
		<div v-show="adProductList.length > 0">
			<h5 class="mt-4">광고상품</h5>
			<table class="table ad-table text-center align-middle">
				<thead>
					<tr>
						<th class="w-2"><input @change="selectAllAdProducts" v-model="allSelected" class="form-check-input" type="checkbox" /></th>
						<th class="w-7">ON/OFF</th>
						<th class="w-6">이미지</th>
						<th class="w-55">상품명</th>
						<th class="w-10">전략</th>
						<th class="w-10">상태</th>
						<th class="w-10">보고서</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="product in adProductList" :key="product.channelProductNo">
						<td class="w-2"><input @change="selectAdProduct" v-model="selectedAdProduts" :value="product.channelProductNo" class="form-check-input" type="checkbox" /></td>
						<td class="w-7">
							<label class="switch">
								<input @change="onoffAd(product)" type="checkbox" v-bind:value="product.channelProductNo" v-model="checkedOnOffAds" />
								<span class="slider round">{{ product.on }}</span>
							</label>
						</td>
						<td class="w-6">
							<a v-bind:href="product.channelProductUrl" target="_blank"><img class="border w-75" v-bind:src="product.imageUrl"/></a>
						</td>
						<td class="w-55">
							<a v-bind:href="product.channelProductUrl" target="_blank">[{{ product.channelName }}] {{ product.channelProductName }}</a>
						</td>
						<td class="w-10" v-if="product.strategy == 1">매출 우선 전략</td>
						<td class="w-10" v-else-if="product.strategy == 2">효율 우선 전략</td>
						<td class="w-10" v-if="product.adStatus == 1">광고중</td>
						<td class="w-10" v-else-if="product.adStatus == 2">광고 검토중</td>
						<td class="w-10" v-else-if="product.adStatus == 4">광고중지</td>
						<td class="w-10">보고서 예정</td>
					</tr>
				</tbody>
			</table>
			<div class="col-lg-12 d-flex flex-row-reverse mt-3 form-switch form-switch-md">
				<button v-on:click="onoffAd('0')" type="button" class="btn btn-outline-primary btn-sm">OFF</button>
				<button v-on:click="onoffAd('1')" type="button" class="btn btn-outline-primary btn-sm mx-3">ON</button>
			</div>
			<hr class="my-5" />
		</div>
		<h5 class="mt-4">광고생성</h5>

		<div class="row justify-content-center mt-4 mb-1">
			<h6 class="text-uppercase mt-3 pb-1">STEP 1: 상품을 선택해주세요.</h6>
			<div class="col-lg-6">
				<div class="card">
					<div v-if="haveProducts" class="card-body">
						<div class="justify-content-between d-flex">
							<div class="w-80">
								<div class="input-group" id="search-input-group">
									<input
										autocomplete="off"
										id="searchProduct"
										v-model="searchProduct"
										@keyup="searchProductName($event)"
										@mouseup="searchProductName()"
										type="text"
										class="rank-item-search bg-white form-control"
										placeholder="내 상품 검색"
										aria-label="Input group example"
										aria-describedby="basic-addon1"
									/>
									<span class="input-group-text bg-white rank-item-search" id="basic-addon1" @mouseup="searchProductName()">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
											<path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"></path>
										</svg>
									</span>
								</div>
							</div>
							<div>
								<button v-on:click="addAllProduct()" type="button" class="btn btn-outline-primary p-2">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
										<path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"></path>
									</svg>
									모두선택
								</button>
							</div>
						</div>
						<ul class="list-group list-group-flush mt-3">
							<li class="list-group-item" v-for="product in currProductList" :key="product.channelProductNo">
								<div class="row justify-content-center d-flex align-items-center">
									<div class="col-lg-2 px-0">
										<a v-bind:href="product.channelProductUrl" target="_blank"><img class="border w-75" v-bind:src="product.imageUrl"/></a>
									</div>
									<div class="col-lg-8 px-0">
										<a v-bind:href="product.channelProductUrl" target="_blank">[{{ product.channelName }}] {{ product.channelProductName }}</a>
									</div>
									<div class="col-lg-2 px-0">
										<button v-if="product.adStatus > 0" disabled type="button" class="btn btn-outline-secondary px-1 py-1 float-end">
											광고상품
										</button>
										<button v-else-if="product.isAdded" disabled type="button" class="btn btn-outline-secondary px-1 py-1 float-end">
											선택완료
										</button>
										<button v-else v-on:click="addProduct(product)" type="button" class="btn btn-outline-primary px-1 py-1 float-end">
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
												<path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"></path>
											</svg>
											선택
										</button>
									</div>
								</div>
							</li>
						</ul>
						<div class="d-flex justify-content-center">
							<nav aria-label="Page navigation example">
								<ul class="pagination pointer">
									<li v-show="previous" class="page-item">
										<button class="page-link" v-on:click="pageLink('p')" aria-label="Previous">
											<span aria-hidden="true">&laquo;</span>
										</button>
									</li>
									<li v-show="pageShow1" class="page-item" v-bind:class="{ active: isActive1 }">
										<button class="page-link" v-on:click="pageLink('1')">{{ pageValue1 }}</button>
									</li>
									<li v-show="pageShow2" class="page-item" v-bind:class="{ active: isActive2 }">
										<button class="page-link" v-on:click="pageLink('2')">{{ pageValue2 }}</button>
									</li>
									<li v-show="pageShow3" class="page-item" v-bind:class="{ active: isActive3 }">
										<button class="page-link" v-on:click="pageLink('3')">{{ pageValue3 }}</button>
									</li>
									<li v-show="pageShow4" class="page-item" v-bind:class="{ active: isActive4 }">
										<button class="page-link" v-on:click="pageLink('4')">{{ pageValue4 }}</button>
									</li>
									<li v-show="pageShow5" class="page-item" v-bind:class="{ active: isActive5 }">
										<button class="page-link" v-on:click="pageLink('5')">{{ pageValue5 }}</button>
									</li>
									<li v-show="next" class="page-item">
										<button class="page-link" v-on:click="pageLink('n')" aria-label="Next">
											<span aria-hidden="true">&raquo;</span>
										</button>
									</li>
								</ul>
							</nav>
						</div>
					</div>
					<div v-else class="card-body">
						상품 정보를 가져오고 있습니다. 상품 수량에 따라 1분이상 소요될 수 있습니다.
					</div>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="card">
					<div class="card-body">
						<div class="justify-content-between d-flex">
							<div class="w-80">총 {{ selectedProductList.length }} 개 상품을 선택했습니다.</div>
							<div>
								<button v-on:click="removeAllProduct" type="button" class="btn btn-outline-primary p-2">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash-lg" viewBox="0 0 16 16">
										<path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z" />
									</svg>
									모두제외
								</button>
							</div>
						</div>

						<ul class="list-group list-group-flush my-3 addedProducts">
							<li class="list-group-item" v-for="product in selectedProductList" :key="product.channelProductNo">
								<div class="row justify-content-center d-flex align-items-center">
									<div class="col-lg-2 px-0">
										<a v-bind:href="product.channelProductUrl" target="_blank"><img class="border w-75" v-bind:src="product.imageUrl"/></a>
									</div>
									<div class="col-lg-8 px-0">
										<a v-bind:href="product.channelProductUrl" target="_blank">[{{ product.channelName }}] {{ product.channelProductName }}</a>
									</div>
									<div class="col-lg-2 px-0">
										<button v-on:click="removeProduct(product)" type="button" class="btn btn-outline-primary px-1 py-1 float-end">
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16">
												<path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
											</svg>
											제외
										</button>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<h6 class="text-uppercase mt-4 pb-1">STEP 2: 전략을 선택해주세요.</h6>
		<div class="row">
			<div class="col-sm-6">
				<div class="card strategy" id="strategy1" @click="strategy(1)">
					<div class="card-body">
						<h5 class="card-title">
							<span>매출 우선 전략</span>
							<span style="float: right;">
								<svg style="fill: #3153fa;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-rocket-takeoff" viewBox="0 0 16 16">
									<path d="M9.752 6.193c.599.6 1.73.437 2.528-.362.798-.799.96-1.932.362-2.531-.599-.6-1.73-.438-2.528.361-.798.8-.96 1.933-.362 2.532Z" />
									<path
										d="M15.811 3.312c-.363 1.534-1.334 3.626-3.64 6.218l-.24 2.408a2.56 2.56 0 0 1-.732 1.526L8.817 15.85a.51.51 0 0 1-.867-.434l.27-1.899c.04-.28-.013-.593-.131-.956a9.42 9.42 0 0 0-.249-.657l-.082-.202c-.815-.197-1.578-.662-2.191-1.277-.614-.615-1.079-1.379-1.275-2.195l-.203-.083a9.556 9.556 0 0 0-.655-.248c-.363-.119-.675-.172-.955-.132l-1.896.27A.51.51 0 0 1 .15 7.17l2.382-2.386c.41-.41.947-.67 1.524-.734h.006l2.4-.238C9.005 1.55 11.087.582 12.623.208c.89-.217 1.59-.232 2.08-.188.244.023.435.06.57.093.067.017.12.033.16.045.184.06.279.13.351.295l.029.073a3.475 3.475 0 0 1 .157.721c.055.485.051 1.178-.159 2.065Zm-4.828 7.475.04-.04-.107 1.081a1.536 1.536 0 0 1-.44.913l-1.298 1.3.054-.38c.072-.506-.034-.993-.172-1.418a8.548 8.548 0 0 0-.164-.45c.738-.065 1.462-.38 2.087-1.006ZM5.205 5c-.625.626-.94 1.351-1.004 2.09a8.497 8.497 0 0 0-.45-.164c-.424-.138-.91-.244-1.416-.172l-.38.054 1.3-1.3c.245-.246.566-.401.91-.44l1.08-.107-.04.039Zm9.406-3.961c-.38-.034-.967-.027-1.746.163-1.558.38-3.917 1.496-6.937 4.521-.62.62-.799 1.34-.687 2.051.107.676.483 1.362 1.048 1.928.564.565 1.25.941 1.924 1.049.71.112 1.429-.067 2.048-.688 3.079-3.083 4.192-5.444 4.556-6.987.183-.771.18-1.345.138-1.713a2.835 2.835 0 0 0-.045-.283 3.078 3.078 0 0 0-.3-.041Z"
									/>
									<path d="M7.009 12.139a7.632 7.632 0 0 1-1.804-1.352A7.568 7.568 0 0 1 3.794 8.86c-1.102.992-1.965 5.054-1.839 5.18.125.126 3.936-.896 5.054-1.902Z" />
								</svg>
							</span>
						</h5>

						<p class="card-text">출시단계의 상품을 광고할 때 추천하는 전략입니다.<br />청산단계에 있는 상품의 재고 소진에도 효과적입니다.</p>
					</div>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="card strategy" id="strategy2" @click="strategy(2)">
					<div class="card-body">
						<h5 class="card-title">
							<span>효율 우선 전략</span>
							<span style="float: right;">
								<svg style="fill: #3153fa;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-graph-up-arrow" viewBox="0 0 16 16">
									<path
										fill-rule="evenodd"
										d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"
									/>
								</svg>
							</span>
						</h5>
						<p class="card-text">판매이력이 있는 경우 추천하는 전략입니다.<br />최소한의 광고비로 판매량을 극대화 할 수 있습니다.</p>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-12 d-flex flex-row-reverse mt-3">
			<button v-on:click="createAd" type="button" class="btn btn-primary btn-lg">광고 생성</button>
		</div>
	</div>
</template>

<script>
import Swal from "../../../../js/sweetalert2.min.js";
import axios from "axios";
import moment from "moment";
import $ from "jquery";
import daterangepicker from "daterangepicker";
import SelectBox from "@toast-ui/select-box";

export default {
	data() {
		return {
			searchProduct: "",
			productList: [], // 전체 상품
			searchProductList: [], // 검색결과 상품 ( 검색값이 없는 경우 전체상품 ) sub 1-1
			currProductList: [], // 현재 페이지 상품 sub 1-2
			selectedProductList: [], // 선택한 상품 sub 1-3
			adProductList: [], // 광고중인 상품  sub 2-1
			selectedAdProduts: [], // 광고중인 상품 중 선택한 상품 sub 2-2
			checkedOnOffAds: [], // 광고중인 상품 중 ON 인 상품
			allSelected: false,
			haveProducts: false,
			strategyVal: 0,
			previous: false,
			countPerPage: 8,
			pageRange: 5,
			pageGroupNum: 0,
			pageShow1: false,
			pageShow2: false,
			pageShow3: false,
			pageShow4: false,
			pageShow5: false,
			pageValue1: 1,
			pageValue2: 2,
			pageValue3: 3,
			pageValue4: 4,
			pageValue5: 5,
			isActive1: false,
			isActive2: false,
			isActive3: false,
			isActive4: false,
			isActive5: false,
			next: false,
			maxAdProducts: 100
		};
	},
	beforeMount() {},
	mounted() {
		this.getChannelProductList();
	},
	methods: {
		invalidSession: function(error) {
			Swal.close();
			if (error && error.response && error.response.status && error.response.status == 401) {
				swal("세션이 만료되었습니다. 다시 로그인 해주세요.").then(() => {
					this.$router.push("/signin");
				});
			} else {
				swal("네트워크에 접속할 수 없습니다.", "네트워크 연결 상태를 확인해주세요.", { icon: "info" });
			}
		},
		serverError: function() {
			Swal.close();
			swal("잠시 후 다시 시도해주세요.", "지속적으로 발생할 경우 우측하단 채널톡으로 문의주세요.", { icon: "info" });
		},

		dateformat: function(current_datetime) {
			var month = current_datetime.getMonth() + 1;
			if (month < 10) {
				month = "0" + month;
			}
			var day = current_datetime.getDate();
			if (day < 10) {
				day = "0" + day;
			}
			let formatted_date = current_datetime.getFullYear() + "년 " + month + "월 " + day + "일";
			return formatted_date;
		},
		numberWithCommas: function(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

		getChannelProductList: function() {
			axios
				.get("/commerce/getChannelProductList")
				.then(response => {
					if (response.status == 200) {
						if (response.data == "Connection refused") {
							console.log("getChannelProductList");
							return;
						}

						let code = response.data.code;
						if (code == -1) {
							this.haveProducts = false;
							swal("상품을 불러오고 있습니다.");
						} else {
							let products = response.data.products;
							if (products.length > 0) {
								this.haveProducts = true;
							}

							this.previous = false;
							products.sort(function(a, b) {
								let atitle = "[" + a.channelName + "] " + a.channelProductName;
								let btitle = "[" + b.channelName + "] " + b.channelProductName;
								return atitle < btitle ? -1 : atitle > btitle ? 1 : 0;
							});

							for (var i = 0; i < products.length; i++) {
								let product = products[i];

								let simpleProduct = {
									originProductNo: product.originProductNo,
									channelProductNo: product.channelProductNo,
									channelName: product.channelName,
									channelProductName: product.channelProductName,
									channelProductUrl: product.channelProductUrl,
									imageUrl: product.imageUrl,
									isAdded: false,
									on: "ON",
									adStatus: product.adStatus,
									strategy: product.strategy
								};
								if (simpleProduct.adStatus > 0) {
									this.adProductList.push(simpleProduct);
									this.checkedOnOffAds.push(simpleProduct.channelProductNo);
								}

								this.productList.push(simpleProduct);
								this.searchProductList.push(simpleProduct);
								if (i < this.countPerPage) {
									this.currProductList.push(simpleProduct);
								}
								if (i == 0) {
									this.pageShow1 = true;
									this.isActive1 = true;
								} else if (i == this.countPerPage * 1) {
									this.pageShow2 = true;
								} else if (i == this.countPerPage * 2) {
									this.pageShow3 = true;
								} else if (i == this.countPerPage * 3) {
									this.pageShow4 = true;
								} else if (i == this.countPerPage * 4) {
									this.pageShow5 = true;
								} else if (i == this.countPerPage * 5) {
									this.next = true;
								}
							}
						}
					}
					this.spinnerEnd();
				})
				.catch(error => {
					this.invalidSession(error);
				});
		},
		strategy: function(e) {
			var strategy1 = document.getElementById("strategy1");
			var strategy2 = document.getElementById("strategy2");
			if (e == 1) {
				this.strategyVal = 1;
				strategy2.classList.remove("selected");
				strategy1.classList.add("selected");
			} else if (e == 2) {
				this.strategyVal = 2;
				strategy1.classList.remove("selected");
				strategy2.classList.add("selected");
			}
		},
		searchProductName: function(event) {
			console.log(event);
			if (event) {
				let searchProduct = event.target.value;
				this.currProductList = [];
				this.searchProductList = [];
				for (var i = 0; i < this.productList.length; i++) {
					let product = this.productList[i];
					let title = "[" + product.channelName + "] " + product.channelProductName;
					product.title = title;
					if (title.toLowerCase().includes(searchProduct.toLowerCase()) || searchProduct.trim() == "") {
						if (this.currProductList.length <= this.countPerPage) {
							this.currProductList.push(product);
						}

						this.searchProductList.push(product);
					}
				}

				this.pageGroupNum = 0;
				this.pageValue1 = this.pageRange * this.pageGroupNum + 1;
				this.pageValue2 = this.pageRange * this.pageGroupNum + 2;
				this.pageValue3 = this.pageRange * this.pageGroupNum + 3;
				this.pageValue4 = this.pageRange * this.pageGroupNum + 4;
				this.pageValue5 = this.pageRange * this.pageGroupNum + 5;

				this.previous = false;
				this.pageShow1 = true;
				this.activePage(1);

				if (this.searchProductList.length > this.countPerPage * 5) {
					this.pageShow2 = true;
					this.pageShow3 = true;
					this.pageShow4 = true;
					this.pageShow5 = true;
					this.next = true;
				} else if (this.searchProductList.length > this.countPerPage * 4) {
					this.pageShow2 = true;
					this.pageShow3 = true;
					this.pageShow4 = true;
					this.pageShow5 = true;
					this.next = false;
				} else if (this.searchProductList.length > this.countPerPage * 3) {
					this.pageShow2 = true;
					this.pageShow3 = true;
					this.pageShow4 = true;
					this.pageShow5 = false;
					this.next = false;
				} else if (this.searchProductList.length > this.countPerPage * 2) {
					this.pageShow2 = true;
					this.pageShow3 = true;
					this.pageShow4 = false;
					this.pageShow5 = false;
					this.next = false;
				} else if (this.searchProductList.length > this.countPerPage * 1) {
					this.pageShow2 = true;
					this.pageShow3 = false;
					this.pageShow4 = false;
					this.pageShow5 = false;
					this.next = false;
				} else {
					this.pageShow2 = false;
					this.pageShow3 = false;
					this.pageShow4 = false;
					this.pageShow5 = false;
					this.next = false;
				}
			}
		},
		pageLink: function(pageNum) {
			let offset = 0;
			let maxPage = Math.ceil(this.searchProductList.length / this.countPerPage);
			let maxPageGroup = Math.ceil(maxPage / this.pageRange) - 1;

			switch (pageNum) {
				case "p":
					this.activePage(1);
					if (this.pageGroupNum > 0) {
						this.pageGroupNum -= 1;
						this.next = true;
					}
					if (this.pageGroupNum == 0) {
						this.previous = false;
					}

					this.pageValue1 = this.pageRange * this.pageGroupNum + 1;
					this.pageValue2 = this.pageRange * this.pageGroupNum + 2;
					this.pageValue3 = this.pageRange * this.pageGroupNum + 3;
					this.pageValue4 = this.pageRange * this.pageGroupNum + 4;
					this.pageValue5 = this.pageRange * this.pageGroupNum + 5;
					this.activePage(5);

					offset = this.countPerPage * (this.pageValue5 - 1);

					this.pageShow5 = true;
					this.pageShow4 = true;
					this.pageShow3 = true;
					this.pageShow2 = true;

					break;
				case "1":
					offset = this.countPerPage * (this.pageValue1 - 1);
					this.activePage(1);
					break;
				case "2":
					offset = this.countPerPage * (this.pageValue2 - 1);
					this.activePage(2);
					break;
				case "3":
					offset = this.countPerPage * (this.pageValue3 - 1);
					this.activePage(3);
					break;
				case "4":
					offset = this.countPerPage * (this.pageValue4 - 1);
					this.activePage(4);
					break;
				case "5":
					offset = this.countPerPage * (this.pageValue5 - 1);
					this.activePage(5);
					break;
				case "n":
					if (this.pageGroupNum < maxPageGroup) {
						this.pageGroupNum += 1;
						this.previous = true;
					}
					console.log(this.pageGroupNum + "/ " + maxPageGroup);
					if (this.pageGroupNum == maxPageGroup) {
						this.next = false;
					}

					this.pageValue1 = this.pageRange * this.pageGroupNum + 1;
					this.pageValue2 = this.pageRange * this.pageGroupNum + 2;
					this.pageValue3 = this.pageRange * this.pageGroupNum + 3;
					this.pageValue4 = this.pageRange * this.pageGroupNum + 4;
					this.pageValue5 = this.pageRange * this.pageGroupNum + 5;
					this.activePage(1);

					offset = this.countPerPage * (this.pageValue1 - 1);

					this.pageValue5 > maxPage ? (this.pageShow5 = false) : (this.pageShow5 = true);
					this.pageValue4 > maxPage ? (this.pageShow4 = false) : (this.pageShow4 = true);
					this.pageValue3 > maxPage ? (this.pageShow3 = false) : (this.pageShow3 = true);
					this.pageValue2 > maxPage ? (this.pageShow2 = false) : (this.pageShow2 = true);
					break;
			}
			this.currProductList = [];
			if (offset < this.searchProductList.length) {
				for (var i = offset; i < this.searchProductList.length; i++) {
					let product = this.searchProductList[i];
					this.currProductList.push(product);
					if (this.currProductList.length == this.countPerPage) {
						break;
					}
				}
			}
		},
		activePage: function(num) {
			switch (num) {
				case 1:
					this.isActive1 = true;
					this.isActive2 = false;
					this.isActive3 = false;
					this.isActive4 = false;
					this.isActive5 = false;
					break;
				case 2:
					this.isActive2 = true;
					this.isActive1 = false;
					this.isActive3 = false;
					this.isActive4 = false;
					this.isActive5 = false;
					break;
				case 3:
					this.isActive3 = true;
					this.isActive1 = false;
					this.isActive2 = false;
					this.isActive4 = false;
					this.isActive5 = false;
					break;
				case 4:
					this.isActive4 = true;
					this.isActive1 = false;
					this.isActive2 = false;
					this.isActive3 = false;
					this.isActive5 = false;
					break;
				case 5:
					this.isActive5 = true;
					this.isActive1 = false;
					this.isActive2 = false;
					this.isActive3 = false;
					this.isActive4 = false;
					break;
			}
		},
		addAllProduct: function() {
			for (var i = 0; i < this.searchProductList.length; i++) {
				if (this.selectedProductList.length >= this.maxAdProducts) {
					swal("등록한도( " + this.maxAdProducts + "개 )에 도달하여 광고 상품을 추가할 수 없습니다.");
					break;
				}
				let product = this.searchProductList[i];
				product.isAdded = true;
				this.selectedProductList.push(product);
			}
		},
		addProduct: function(product) {
			if (this.selectedProductList.length >= this.maxAdProducts) {
				swal("등록한도( " + this.maxAdProducts + "개 )에 도달하여 광고 상품을 추가할 수 없습니다.");
			} else {
				product.isAdded = true;
				this.selectedProductList.push(product);
			}
		},
		removeAllProduct: function() {
			for (var i = 0; i < this.selectedProductList.length; i++) {
				let product = this.selectedProductList[i];
				product.isAdded = false;
				product.adStatus = 0;
			}
			this.selectedProductList = [];
		},
		removeProduct: function(product) {
			for (var i = 0; i < this.selectedProductList.length; i++) {
				if (this.selectedProductList[i] === product) {
					product.isAdded = false;
					product.adStatus = 0;
					this.selectedProductList.splice(i, 1);
					break;
				}
			}
		},
		createAd() {
			this.errors = [];
			if (this.strategyVal == 0) {
				this.errors.push("전략을 선택해주세요.");
			}
			if (this.selectedProductList.length == 0) {
				this.errors.push("상품을 선택해주세요.");
			}
			if (this.errors.length > 0) {
				swal(this.errors[0]);
				return true;
			}

			let channelProductNos = [];
			for (var product of this.selectedProductList) {
				channelProductNos.push(product.channelProductNo);
			}

			let form = new FormData();
			form.append("strategy", this.strategyVal);
			form.append("productNoList", channelProductNos);

			this.callCreateAd(form);
			swal("광고생성을 시작합니다.", "실제 광고가 게재되는 데까지 1시간에서\n최대 3일까지 소요될 수 있습니다.", { icon: "success" });
		},
		async callCreateAd(form) {
			const response = await axios.post("/ad/createAd", form);
			console.log(response);

			if (response.status != 200) {
				swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. \n 계속 발생하는 경우 우측하단 채널톡 통해\n 문의해주세요.", { icon: "info" });
				return;
			}
			if (!response.data || !response.data.code || response.data.code != 1) {
				swal("광고를 생성할 수 없습니다.\n우측하단 채널톡 통해 문의해주세요.");
				return;
			}

			// 광고 생성 중 제외버튼을 눌렀을 때
			let adProductList = response.data.adProductList;
			for (let adProduct of adProductList) {
				adProduct.isAdded = true;
				adProduct.on = "ON";
				this.checkedOnOffAds.push(adProduct.channelProductNo);
				this.adProductList.push(adProduct);
				for (var i = 0; i < this.selectedProductList.length; i++) {
					let product = this.selectedProductList[i];
					if (product.channelProductNo == adProduct.channelProductNo) {
						this.selectedProductList.splice(i, 1);
						i--;
						break;
					}
				}
			}

			// for (var i = 0; i < this.selectedProductList.length; i++) {
			//     let product = this.selectedProductList[i]
			//     for(let adProduct of adProductList){
			//         if( product.channelProductNo == adProduct.channelProductNo ){
			//             product.strategy=adProduct.strategy
			//             product.adStatus=adProduct.adStatus
			//             product.isAdded = true
			//             product.on = 'ON'
			//             this.checkedOnOffAds.push(product.channelProductNo)
			//             this.adProductList.push(product)
			//             this.selectedProductList.splice(i, 1);
			//             i--;
			//             break
			//         }
			//     }
			// }
			console.log("wait1");
		},

		selectAllAdProducts: function() {
			this.selectedAdProduts = [];
			if (this.allSelected) {
				for (let product of this.adProductList) {
					this.selectedAdProduts.push(product.channelProductNo);
				}
			}
		},
		selectAdProduct: function() {
			if (this.adProductList.length == this.selectedAdProduts.length) {
				this.allSelected = true;
			} else {
				this.allSelected = false;
			}
		},
		// async onoffAdAll() {
		// 	// 체크한 것 가져오기
		// 	const response = await axios.post("/ad/createAd", form);
		// 	console.log(response);
		// },
		async onoffAd(product) {
			// 아직 단건 처리만 가능한 함수
			let channelProductNo = product.channelProductNo;
			// 포함 = on, 아니면 off
			let onOff = false;
			for (let productNo of this.checkedOnOffAds) {
				if (channelProductNo == productNo) {
					onOff = true;
				}
			}

			product.on = onOff ? "ON" : "OFF";
			let adStatus = onOff ? 1 : 4;

			console.log(onOff);

			let channelProductNos = [];
			channelProductNos.push(product.channelProductNo);

			let form = new FormData();
			form.append("channelProductNoList", channelProductNos);
			form.append("adStatus", adStatus);
			this.loginSuccess = false;
			this.spinnerStart();
			const response = await axios.post("/ad/editAdStatus", form);
			console.log(response);

			this.spinnerEnd();

			if (response.status == 200) {
				let code = response.data.code;
				let channelProductList = response.data.channelProductList;
				switch (code) {
					case 1:
						swal("광고를 삭제했습니다.");
						for (var i = 0; i < this.adProductList.length; i++) {
							let product = this.adProductList[i];
							for (let adProduct of channelProductList) {
								if (product.channelProductNo == adProduct.channelProductNo) {
									product.strategy = 0;
									product.adStatus = 0;
									this.adProductList.splice(i, 1);
									i--;
									break;
								}
							}
						}

						for (var i = 0; i < this.currProductList.length; i++) {
							let product = this.currProductList[i];
							for (let adProduct of channelProductList) {
								if (product.channelProductNo == adProduct.channelProductNo) {
									product.strategy = 0;
									product.adStatus = 0;
									product.isAdded = false;
									break;
								}
							}
						}

						this.selectedAdProduts = [];

						break;
					default:
						swal("광고 삭제에 실패했습니다.\n 새로고침 후 다시 이용해주세요. -2");
						break;
				}
			} else {
				swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -2", { icon: "info" });
			}
		},
		spinnerStart: function() {
			let preloader = document.getElementById("preloader");
			preloader.style.visibility = "visible";
			preloader.style.opacity = "0.5";
			preloader.style.background = "#000";
		},
		spinnerEnd: function() {
			let preloader = document.getElementById("preloader");
			preloader.style.visibility = "hidden";
			preloader.style.opacity = "0";
		}
	}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/main/naverad/Manage.vue